import { UploadPredeliveryAction } from 'src/modals/PurchaseWizard/PurchaseTicketsFlow/purchaseTicketsFlow.utils';
import {
  Event,
  Performer,
  TicketGroupEditReason,
  TicketGroupInput,
  Venue,
} from 'src/WebApiController';

export const Steps = {
  PurchaseVendorInfoStep: 'PurchaseVendorInfoStep',
  PurchaseWizardMainStep: 'PurchaseWizardMainStep',
  TicketGroupInputStep: 'TicketGroupInputStep',
  TicketGroupBlankInputStep: 'TicketGroupBlankInputStep',
} as const;

export const AddActions = [
  TicketGroupEditReason.EditEvent,
  TicketGroupEditReason.ExchangeTickets,
  TicketGroupEditReason.AddTickets,
];

export const TicketGroupInputSteps: (keyof typeof Steps)[] = [
  Steps.TicketGroupInputStep,
  Steps.TicketGroupBlankInputStep,
];

export type AmendActionData = {
  uploadPredeliveryAction: UploadPredeliveryAction | undefined;
};

export type TicketGroupEditContextAdditionalData = {
  event?: Event | null;
  performer?: Performer | null;
  venue?: Venue | null;
  amendActionData?: AmendActionData;
  /**
   * Source ticket group to copy from when adding tickets ("Copy tickets"). When
   * set, the new group is seeded from it (seating/cost/qty) for the chosen event.
   */
  sourceTicketGroup?: TicketGroupInput | null;
  /** Source groups to copy from at the event level ("Copy tickets" for an event). */
  sourceTicketGroups?: TicketGroupInput[] | null;
  /**
   * When copying tickets into multiple events, whether to split the source
   * unit/face-value cost across the picked events (true) or copy it untouched
   * (false). Chosen by the user via the "Split Unit Cost?" dialog.
   */
  splitCostAcrossEvents?: boolean;
};

export type TicketGroupEditContext = {
  startWithEventSearch: boolean;
  ticketGroupId: number;
  ticketGroupIdToRemove?: number; // in the case of exchange
  editIntention: TicketGroupEditReason;
  editInfo: string;
  additionalData?: TicketGroupEditContextAdditionalData;
};
